import React, { useEffect, useState, useRef } from "react";
import logo from "../../../../../img/IconLogo.png";
import styless from "./CourseContent.module.css";
import parse from "html-react-parser";
import { AxiosInstance } from "../../../../../axios";
import { useParams } from "react-router-dom";
import { ImageUrlPrefix } from "../../../../../labels";
import UpcomingBatchTemplate from "../../../../../pages/dashboard/UpcomingBatchTemplate";
import styles from "../../../../../pages/dashboard/CourseCategory.module.css";
import Select, { components } from "react-select";

const CourseContent = (props) => {
  const { id, name } = useParams(); // Extract category ID from route
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState({ id: "", name: "" });
  const [htmldata, setHtmlData] = useState("");
  const tabRef = useRef();
  // const [activeTabName, setActiveTabName] = useState("");
  const [admissionType, setAdmissionType] = useState("0"); // Default to Course
  const [branch, setBranch] = useState("2"); // Default to Kanchipuram
  const [activeTab, setActiveTab] = useState(0);
  const [batchMode, setBatchMode] = useState("Classroom");
  const [selectedBatchDetails, setSelectedBatchDetails] = useState([]); // Default to offline
  const userJSON = sessionStorage.getItem("userDetails");
  let user_type = null;
  const admissionTypeMap = {
    0: "Course",
    1: "Test",
    2: "Counselling",
    3: "Special Class",
    4: "Model Exam",
    5: "Mock Interview",
  };

  if (userJSON) {
    const user = JSON.parse(userJSON);
    user_type = user.user_type;
  }

  // Fetch course list based on id
  useEffect(() => {
    fetchCourseList();
  }, [id]); // This will trigger whenever `id` changes

  const fetchCourseList = async () => {
    try {
      setCourses([]);
      setSelectedCourse({ id: "", name: "" });
      setHtmlData("");
      setActiveTab(0);
      // setActiveTabName(name);
      const response = await AxiosInstance.post("api/course/courselist", {
        type: "",
        search: "",
        category: [parseInt(id)], // Use id from route
        group_id: "",
      });
      if (response.data.status === true && response.data.data) {
        const data = response.data?.data || [];
        const uniqueData = Array.from(
          new Map(data.map((item) => [item.group_course_id, item])).values()
        );
        setCourses(uniqueData);
        fetchCourseContent([uniqueData[0]]);
        setSelectedCourse({
          id: uniqueData[0]?.group_course_id,
          name: uniqueData[0]?.group_course_name,
        });
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error fetching course list:", error);
      setHtmlData("<p>Failed to load course content.</p>");
    }
  };

  // Function to fetch course content
  const fetchCourseContent = async (course) => {
    const courseContentUrl = course[0]?.course_content_path
      ? `/${course[0]?.course_content_path}`
      : null;
    if (courseContentUrl) {
      try {
        // Fetch course content
        const response = await AxiosInstance.get(courseContentUrl, {
          headers: {
            "Content-Type": "text/html",
          },
        });
        setHtmlData(response.data); // Set the fetched HTML content
      } catch (error) {
        console.error("Error fetching course content:", error);
        setHtmlData("<p>Failed to load course content.</p>");
      }
    } else {
      setHtmlData(`<div class="row"><p class="no-records">Course information will be available soon. Please reach out to the admin if you need immediate assistance.</p></div>`);
      setActiveTab(0);
    }
  };

  const getSeletedBatchDetails = async () => {
    try {
      const req = {
        category: name ? [name] : [],
        status: [1, 2],
        batch_type: "",
        group_course_id: selectedCourse?.id || "",
        medium: "",
        class_mode: batchMode ? [batchMode] : "",
        start_date: "",
        end_date: "",
        c_start_date: "",
        c_end_date: "",
        start_time: "",
        end_time: "",
        search: "",
        discount: 0,
        old_stud_disc_sum: "",
        fees: "",
        exam_fees: "",
        type: admissionType ? admissionType : "",
        location: batchMode === "Classroom" ? (branch ? [branch] : "") : [2],
        is_allowed_admission: 1,
      };

      const res = await AxiosInstance.post("api/batch/list", req);

      if (res.data.status === true) {
        const data = res.data?.data || [];
        setSelectedBatchDetails(data);
      } else {
        setSelectedBatchDetails([]);
      }
    } catch (error) {
      console.error("Error fetching batch data:", error);
      setSelectedBatchDetails([]);
    }
  };

  useEffect(() => {
    if (activeTab === 1) {
      getSeletedBatchDetails();
    }
  }, [activeTab, admissionType, batchMode, branch]);

  const handleCourseChange = async (id, name) => {
    setSelectedCourse({ id, name });
    setHtmlData("<p>Loading course content...</p>");

    try {
      const response = await AxiosInstance.get(
        `api/course/getGroupCourse/${id}`
      );
      if (response.data.status === true && response.data.data) {
        getSeletedBatchDetails();
        fetchCourseContent(response.data.data);
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error fetching course content:", error);
      setHtmlData("<p>Error loading course content.</p>");
    }
  };

  useEffect(() => {
    const admissionTab = document.getElementById("admission-tab-pane");
    if (admissionTab && activeTab === 1) {
      admissionTab.style.display = "none";
    }
  }, [activeTab]);

  // Second useEffect for handling tab shown event
  useEffect(() => {
    const handleTabShown = (event) => {
      const activeTabContentId = event.target.getAttribute("data-bs-target");
      // console.log("Active Tab Content ID:", activeTabContentId);
      if (activeTabContentId === "#admission-tab-pane") {
        // getAiasaBranches({});
        setActiveTab(1);
        // debugger;
        // fetchBatchData();
      } else {
        setActiveTab(0);
      }
    };

    // Attach event listener
    const tabs = tabRef.current.querySelectorAll(
      'button[data-bs-toggle="tab"]'
    );
    tabs.forEach((tab) => {
      tab.addEventListener("shown.bs.tab", handleTabShown);
    });

    // Cleanup on component unmount
    return () => {
      tabs.forEach((tab) => {
        tab.removeEventListener("shown.bs.tab", handleTabShown);
      });
    };
  }, [htmldata]);

  const handleAdmissionTypeChange = (event) => {
    const newAdmissionType = event.target.value;
    setAdmissionType(newAdmissionType);
    // setActiveTab(0);
    // // Set default branch and batchMode based on admission type
    // if (newAdmissionType === "4") {
    //   setBranch("2"); // Default to offline batches
    //   setBatchMode("2"); // Default to offline
    // }
    // fetchCourseList();
  };

  const handleBranchChange = (event) => {
    const newValue = event.target.value;
    setBranch(newValue);

    // Set batch mode based on branch selection
    if (admissionType === "4") {
      setBatchMode(newValue); // Set to the selected value
    }
  };

  const handleBatchModeChange = (e) => {
    const selectedMode = e.target.value;
    setBatchMode(selectedMode);

    // If Online is selected, disable location selection
    if (selectedMode === "Online") {
      setBranch("20"); // Reset location
    } else {
      setBranch("2"); // Default to Kanchipuram for Offline
    }
  };

  const handleJoinNow = (batch) => {
    // Store batch data in sessionStorage
    sessionStorage.setItem("selectedBatch", JSON.stringify(batch));

    const userJSON = sessionStorage.getItem("userDetails");
    let userid = null;

    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        userid = user.user_id;
      }
    }

    if (!userid) {
      // Store the desired path in sessionStorage
      sessionStorage.setItem(
        "redirectPath",
        JSON.stringify({
          type: batch.type,
          id: batch.id, // You might want to store more information if needed
        })
      );

      // Navigate to login screen
      // navigate("/login");
      window.location.href = "/login";
    } else {
      // If user is logged in, navigate based on admission type
      navigateToAdmission(batch.type);
    }

    // console.log("Batch data stored:", batch);
  };

  const navigateToAdmission = (admissionType) => {
    if (admissionType === 0) {
      // navigate("/Admission/Course", {});
      window.location.href = "/Admission/Course";
    } else if (admissionType === 1) {
      // navigate("/Admission/TestBatch");
      window.location.href = "/Admission/TestBatch";
    } else if (admissionType === 3) {
      // navigate("/Admission/SpecialClasses");
      window.location.href = "/Admission/SpecialClasses";
    } else if (admissionType === 4) {
      // navigate("/Admission/Modelexam");
      window.location.href = "/Admission/Modelexam";
    } else {
      console.log("Unknown admission type:", admissionType);
    }
  };
  const courseOptions = courses.map((course) => ({
    value: course.group_course_id,
    label: course.group_course_name,
  }));

  const handleSelectChange = (selectedOption) => {
    const selectedCourseId = selectedOption?.value || "";
    const selectedCourseName = selectedOption?.label || "";

    handleCourseChange(selectedCourseId, selectedCourseName);
    setActiveTab(0);
  };
  return (
    <div className="container-fluid my-4">
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          minHeight: "750px",
        }}
      >
        <img src={logo} alt="Overlay" className="overlay-image" />

        <div style={{ position: "relative", zIndex: 2 }}>
          <div className="row align-items-center">
            <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
              <h6 className={`${styless.head_Title} mx-2`}>
                {selectedCourse.name || "Please select a course"}
              </h6>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-12 text-lg-end text-sm-center text-start">
              <div
                className={`${styless.cc_head} head_title_second  d-flex justify-content-end align-items-center`}
              >
                <a href="/" className={`${styless.back_bnt} me-2`}>
                  Back to Home
                </a>

                <Select
                  className={`  ${styless.customSelectWidth} shadow-none input-font-size`}
                  // classNamePrefix="custom-select"
                  styles={{zIndex:9}}
                  id="course"
                  name="course"
                  options={courseOptions}
                  value={courseOptions.find(
                    (option) => option.value === selectedCourse.id
                  )}
                  onChange={handleSelectChange}
                  isSearchable
                  placeholder={
                    courses.length > 0
                      ? "Select a Course"
                      : "No courses available"
                  }
                  isDisabled={courses.length === 0}
                />
              </div>
            </div>
          </div>

          {/* Renders the fetched HTML content */}
          <div ref={tabRef}>{parse(htmldata)}</div>

          {activeTab > 0 && (
            <div className="d-flex flex-lg-row justify-content-lg-end flex-column">
              {/* Choose Your Course */}
              <div className="d-flex flex-column mx-3">
                <label
                  htmlFor="admissionType"
                  className={styles.confirm_value1}
                >
                  Choose Your Course
                </label>
                <select
                  id="admissionType"
                  className={`${styles.custom_width} ${styles.dropdownarrow_img} ${styles.select} ${styles.cursorPtn} form-select my-2`}
                  aria-label="Select admission type"
                  onChange={handleAdmissionTypeChange}
                  value={admissionType}
                >
                  <option value="0">Courses</option>
                  <option value="1">Test Batches</option>
                  <option value="3">Special Classes</option>
                  <option value="4">Model Exams</option>
                  <option value="5">Mock Interview</option>
                  <option value="2">Counselling</option>
                </select>
              </div>

              {/* Choose Your Learning Mode */}
              <div className="d-flex flex-column mx-3">
                <label htmlFor="batchMode" className={styles.confirm_value1}>
                  {admissionType === "4"
                    ? "Choose Your Exam Mode"
                    : "Choose Your Learning Mode"}
                </label>
                <select
                  id="batchMode"
                  className={`${styles.dropdownarrow_img} ${styles.custom_width} ${styles.select} ${styles.cursorPtn} form-select my-2`}
                  aria-label="Select batch mode"
                  onChange={handleBatchModeChange} // Updated function
                  value={batchMode}
                >
                  <option value="Classroom">Offline</option>
                  <option value="Online">Online</option>
                </select>
              </div>

              {/* Choose Your Location (Enabled/Disabled based on Learning Mode & Admission Type) */}
              <div className="d-flex flex-column mx-3">
                <label
                  htmlFor="branch"
                  className={`${styles.confirm_value1} `}
                  // style={{ color: batchMode === "20" ? "#ccc" : "inherit" }} // Grayed out label when disabled
                  style={{
                    color:
                      batchMode === "Online" || admissionType === "4"
                        ? "#ccc"
                        : "inherit",
                    opacity:
                      batchMode === "Online" || admissionType === "4" ? 0.8 : 1, // Reduce opacity when disabled
                    // cursor: batchMode === "Online" ? "not-allowed" : "default", // Disable cursor
                  }}
                >
                  Choose Your Location
                </label>
                <select
                  id="branch"
                  className={`${styles.dropdownarrow_img} ${styles.custom_width} ${styles.select} ${styles.cursorPtn} form-select my-2`}
                  aria-label="Select branch"
                  onChange={handleBranchChange}
                  value={branch}
                  style={{
                    color:
                      batchMode === "Online" || admissionType === "4"
                        ? "#ccc"
                        : "inherit",
                    opacity:
                      batchMode === "Online" || admissionType === "4" ? 0.8 : 1, // Reduce opacity when disabled
                    cursor:
                      batchMode === "Online" || admissionType === "4"
                        ? "not-allowed"
                        : "default", // Disable cursor
                  }}
                  disabled={batchMode === "Online" || admissionType === "4"} // Disable select when Online is selected
                >
                  <option value="" disabled>
                    Choose Your Location
                  </option>

                  {admissionType === "4" || batchMode !== "Classroom" ? (
                    <option
                      value="20"
                      disabled
                      className={styles.disabledLabel}
                    >
                      Choose Your Location
                    </option>
                  ) : (
                    <>
                      <option value="1">Tambaram</option>
                      <option value="2">Kanchipuram</option>
                      <option value="3">Vellore</option>
                      <option value="4">Chennai</option>
                    </>
                  )}
                </select>
              </div>
            </div>
          )}

          <fieldset
            className="rounded-3"
            style={{ display: activeTab > 0 ? "block" : "none" }}
          >
            <legend>
              {selectedBatchDetails.length > 0
                ? admissionTypeMap[selectedBatchDetails[0].type]
                : admissionTypeMap[admissionType]}
            </legend>
            {selectedBatchDetails.length > 0 ? (
              selectedBatchDetails.map((batch) => (
                <div className="card p-3 mb-3" key={batch.id}>
                  <div className="row">
                    <div className="col-lg-10 col-12">
                      <UpcomingBatchTemplate batch={batch} />
                    </div>
                    <div className="col-lg-2 col-12">
                      <div
                        className={`${styles.UpcommingBatchImage} mb-2`}
                        style={{ textAlign: "center" }}
                      >
                        <img
                          src={`${ImageUrlPrefix}/${batch.img_url}`}
                          // className={`${styles.course_img} mb-2`}
                          alt="course_img"
                        />
                      </div>

                      {/* <button
                            type="button"
                            className={`${styles.SaveButton} w-100`}
                            onClick={() => handleJoinNow(batch)}
                          >
                            Join Now
                          </button> */}
                      {(user_type === 2 || user_type === null) && (
                        <button
                          type="button"
                          className={`${styles.SaveButton} w-100`}
                          onClick={() => handleJoinNow(batch)}
                        >
                          <span className={styles.buttonText}>Join Now</span>
                          <span className={styles.arrowIcon}>&rarr;</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>
                We currently have no batches scheduled for the selected
                Admission Type and Location. Please check back soon for updates
                on upcoming batches.
              </p>
            )}
          </fieldset>
        </div>
      </div>
    </div>
  );
};

export default CourseContent;
